import { Link } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";
import TopWedge from "@/components/TopWedge";
import { Eyebrow, Headline } from "@/components/Editorial";
import { C } from "@/lib/brand";

const CONTENT = {
  terms: {
    title: "Terms of Service",
    eyebrow: "★ LEGAL / TERMS",
    body: [
      ["Effective date: January 2026"],
      ["1. Acceptance.", "By creating a VOYA9 account or using our services you agree to these Terms. If you don't agree, don't use our services."],
      ["2. Eligibility.", "You must be at least 18 years old and a U.S. resident to use VOYA9. Some programs are restricted by state."],
      ["3. Telehealth services.", "VOYA9 connects you with licensed physicians via the Healthy Horizons clinical network. Physician services are provided by independent licensed practitioners — not by VOYA9 itself."],
      ["4. Subscriptions & cancellation.", "Subscriptions auto-renew monthly until you pause or cancel. You can pause, skip, or cancel at any time from your account."],
      ["5. Refunds.", "Consultation fees are generally non-refundable once a physician has reviewed your case. Subscription orders that have not yet shipped may be refunded; shipped orders are not eligible for refund."],
      ["6. Acceptable use.", "Don't misuse our service: no fraud, no harm, no impersonation, no scraping."],
      ["7. Limitation of liability.", "VOYA9 is provided \"as is\". Our maximum liability is capped at the amount you paid us in the prior 12 months."],
      ["8. Changes.", "We may update these Terms. Material changes will be communicated via email."],
    ],
  },
  privacy: {
    title: "Privacy Policy",
    eyebrow: "★ LEGAL / PRIVACY",
    body: [
      ["Effective date: January 2026"],
      ["What we collect.", "Account info (name, email, phone, address), health information you provide in assessments, payment info (handled by Stripe — we never store card numbers), and basic usage analytics."],
      ["How we use it.", "To provide care, fulfill orders, communicate with you, prevent fraud, and improve our service."],
      ["Sharing.", "We share PHI with the licensed physicians providing your care, our pharmacy and shipping partners, Stripe (payments), and as required by law. We never sell your data."],
      ["Your rights.", "You can request access, correction, or deletion of your data at any time. Email care@voya9.com."],
      ["Security.", "We encrypt data in transit and at rest. Access is logged and minimized."],
    ],
  },
  telehealth: {
    title: "Telehealth Informed Consent",
    eyebrow: "★ LEGAL / TELEHEALTH",
    body: [
      ["About telehealth.", "Telehealth involves the use of electronic communications to enable healthcare providers at different locations to share patient information for the purpose of evaluation and treatment."],
      ["Risks & benefits.", "Benefits include greater access to care and convenience. Risks include the possibility, despite reasonable efforts, that information transmitted may not be sufficient to allow appropriate decision-making by the provider."],
      ["Your rights.", "You have the right to withhold or withdraw consent at any time without affecting your right to future care. You may inspect all information obtained and recorded in the course of a telehealth interaction."],
      ["Consent.", "By creating a VOYA9 account and submitting an assessment you consent to telehealth services as described above."],
    ],
  },
};

export default function LegalPage({ kind }) {
  const c = CONTENT[kind];
  return (
    <div data-testid={`legal-${kind}-page`} style={{ background: C.cream }}>
      <PublicNav variant="dark" />
      <section style={{ background: C.ink, color: C.cream, padding: "80px 24px 96px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <Eyebrow color={C.peach}>{c.eyebrow}</Eyebrow>
          <Headline before={c.title.split(" ").slice(0, -1).join(" ").toUpperCase()} italic={c.title.split(" ").slice(-1).join(" ").toLowerCase() + "."} color={C.cream} italicColor={C.peach} size={64} className="mt-6" />
        </div>
      </section>
      <section style={{ background: C.cream, padding: "92px 24px 120px", position: "relative" }}>
        <TopWedge color={C.ink} dir="right" />
        <div style={{ maxWidth: 760, margin: "0 auto", fontSize: 16, lineHeight: 1.7, color: C.ink, position: "relative", zIndex: 2 }}>
          {c.body.map(([h, body], i) => (
            <div key={i} style={{ marginBottom: 28 }}>
              <strong style={{ display: "block", marginBottom: 6 }}>{h}</strong>
              {body && <div style={{ color: C.warmGray }}>{body}</div>}
            </div>
          ))}
          <div style={{ marginTop: 48 }}>
            <Link to="/" data-testid="legal-back-link" style={{ fontSize: 12, fontWeight: 800, letterSpacing: "0.18em", color: C.ink, textDecoration: "none" }}>← BACK TO HOME</Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
